import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  carousel: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  retrieveAccount: { marginTop: `${theme.spacing(2)} !important` },
  progress: { color: "#FFF" },
}));
